"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TrackedCategoryMenu = void 0;

var _preact = require("preact");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _trackingLink = _interopRequireDefault(require("../link/tracking-link"));

var _categoryMenu = _interopRequireDefault(require("./categoryMenu"));

var _excluded = ["item"];

var TrackedCategoryMenu = function TrackedCategoryMenu(_ref) {
  var item = _ref.item,
      restProps = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return (0, _preact.h)(_trackingLink.default, {
    tag: "li",
    className: "header-navigation_list-item main-menu",
    track: {
      type: "Mega Menu click on ".concat(item.key, " module"),
      event_source: 'control'
    },
    "data-qa": "mega-menu-item-".concat(item.name.split(' ').join('_'))
  }, (0, _preact.h)(_categoryMenu.default, (0, _extends2.default)({
    name: item.name,
    item: item
  }, restProps)));
};

exports.TrackedCategoryMenu = TrackedCategoryMenu;